<template>
  <div>
    <h1>Alert Details</h1>
    <p>Alert ID: {{ itemId }}</p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      itemId: null,
    };
  },
  created() {
    this.itemId = this.$route.params.sensorId;
  },
  watch: {
    "$route.params.id"(newId) {
      this.itemId = newId;
      console.log("Item ID updated:", newId);
    },
  },
};
</script>
